export default {
  guardiao_protetor: [
    {
      name: 'Elmo da Honra',
      pv: 10,
      def: 2
    },

    {
      name: 'Insígnia da Força',
      dmg: 1,
      def: 1
    },

    {
      name: 'Talismã de Rubi',
      def: 1
    }
  ],

  ninja: [
    {
      name: 'Agulha Envenenada',
      desc:
        'Pode ser ativada duas vezes na batalha. Pode atacar um oponente até 3 quadrados de distância. Envenena o alvo por 1 rodada.'
    },

    {
      name: 'Colar de Chakra',
      pv: 5,
      ph: 1
    },

    {
      name: 'Kunai Tempestade',
      desc:
        'Pode ser ativada uma vez na batalha. Permite teletransportar para qualquer lugar do campo de batalha.'
    }
  ],

  necromante: [
    {
      name: 'Talismã das Profundezas',
      ph: 1,
      dmg: 2
    },

    {
      name: 'Grimório Milenar',
      dmg: 1,
      def: 1
    },

    {
      name: 'Colar de Chakra',
      pv: 5,
      ph: 1
    }
  ],

  alquimista: [
    {
      name: 'Óculos Detector',
      dmg: 1,
      def: 2
    },

    {
      name: 'Botas da Agilidade',
      mov: 1
    },

    {
      name: 'Luvas Mágicas',
      dmg: 1
    }
  ],

  monge: [
    {
      name: 'Pergaminho da Sabedoria Suprema',
      mov: 1,
      dmg: 2,
      def: 2,
      desc: 'Depois de ativado o personagem perde 2 pontos de PV por rodada'
    },

    {
      name: 'Tatuagem do Caminho dos Ventos',
      mov: 1,
      def: 1
    },

    {
      name: 'Colar de Chakra',
      pv: 5,
      ph: 1
    }
  ],

  ladino: [
    {
      name: 'Anel de Rubi Sangue',
      pv: 10
    },

    {
      name: 'Insígnia do Submundo',
      dmg: 1,
      ph: 1
    },

    {
      name: 'Botas da Agilidade',
      mov: 1
    }
  ],

  bardo: [
    {
      name: 'Palheta de Ouro',
      dmg: 2
    },

    {
      name: 'Bracelete do Andarilho',
      ph: 1,
      mov: 1
    },

    {
      name: 'Flauta de Bambu',
      ph: 1
    }
  ],

  mestre_modelador: [
    {
      name: 'Tatuagem das Eras',
      pv: -3,
      ph: 1,
      def: 2
    },

    {
      name: 'Orbe Luminar',
      ph: 1,
      mov: 1
    },

    {
      name: 'Anel das Estrelas',
      ph: 2
    }
  ],

  barbaro: [
    {
      name: 'Marcas de Guerra',
      dmg: 1,
      def: 2
    },

    {
      name: 'Colar de Ossos',
      dmg: 2
    },

    {
      name: 'Pé de Dragão Bebê',
      ph: 1,
      dmg: 1
    }
  ],

  mercenario: [
    {
      name: 'Elmo de Marfim Negro',
      pv: 5,
      def: 2
    },

    {
      name: 'Caneleira de Couro de Rinoceronte',
      dmg: 1,
      def: 1
    },

    {
      name: 'Luva de Casco de Tartaruga',
      dmg: 1
    }
  ],

  mago: [
    {
      name: 'Pingente de Almas',
      ph: 1,
      dmg: 2
    },

    {
      name: 'Grimório Milenar',
      dmg: 1,
      def: 1
    },

    {
      name: 'Chapéu de Palha',
      def: 1
    }
  ],

  cacador: [
    {
      name: 'Diário de Caça',
      dmg: 2,
      def: 1
    },

    {
      name: 'Bracelete de Marfim Rosado',
      def: 2
    },

    {
      name: 'Colar de Dente de Tigre Albino',
      pv: 5
    }
  ],

  guerreiro: [
    {
      name: 'Insígnia da Vitória',
      pv: 10,
      dmg: 2
    },

    {
      name: 'Cinto dos Touros',
      dmg: 2
    },

    {
      name: 'Talismã de Rubi',
      def: 1
    }
  ],

  arqueiro: [
    {
      name: 'Capa de Camuflar',
      def: 2
    },

    {
      name: 'Luvas de Atirador',
      dmg: 1,
      def: 1
    },

    {
      name: 'Aljava de Couro',
      dmg: 1
    }
  ],

  clerigo: [
    {
      name: 'Pingente com Lágrimas de Deus',
      pv: 10,
      ph: 1
    },

    {
      name: 'Livro de Orações',
      dmg: 1,
      def: 1
    },

    {
      name: 'Insígnia da Vida',
      pv: 5
    }
  ],

  juiz: [
    {
      name: 'Livro dos Condenados',
      ph: 1,
      dmg: 2
    },

    {
      name: 'Insígnia da Justiça',
      ph: 1,
      dmg: 1
    },

    {
      name: 'Broquel Imperial',
      def: 1
    }
  ],

  general: [
    {
      name: 'Cinto dos Touros',
      dmg: 2
    },

    {
      name: 'Insígnia da Liderança',
      pv: 5,
      def: 1
    },

    {
      name: 'Livro de Estratégias',
      def: 1
    }
  ],

  assassino: [
    {
      name: 'Insígnia da Morte',
      dmg: 3
    },

    {
      name: 'Colar de Olhos',
      def: 2
    },

    {
      name: 'Botas da Agilidade',
      mov: 1
    }
  ],

  xama: [
    {
      name: 'Colar de Almas',
      pv: 10,
      ph: 1
    },

    {
      name: 'Chocalho de Nagah',
      ph: 2
    },

    {
      name: 'Livro de Invocações',
      dmg: 1
    }
  ],

  mimico: []
}
